/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { FormResolveType } from "../../redux/AppStateSlice";
import { Button, ButtonSize, ButtonVariant, FormInput, MITheme } from "@spectrumselect/mi-ui-react";
import { ErrorMessage } from "../../components/errorMessage/ErrorMessage";
import { S } from "../../auth/sdk";
import { MAILTOFOGOTPASSWORD } from "../../utils/constants";
import "./CollectUsernameForm.scss";

interface CollectUsernameFormProps {
  errorMessage?: string;
  resolve?: FormResolveType;
  tenant?: string;
  username?: string;
  isActivation: boolean;
}

export const CollectUsernameForm: React.FunctionComponent<CollectUsernameFormProps> = (props) => {
  const [userId, setUserId] = useState(props?.username || "");
  const onSubmitButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (userId) {
      props.resolve && props.resolve(S.FormInput.createFormInputSubmissionRequest({ actions: { username: userId } }))
    }
  }
  const onCancelButtonClick = () => {
    props.resolve && props.resolve(S.FormInput.createFormCancellationRequest());
  }

  return (
    <form className="CollectUsernameForm App_formInputGroup">
      <h1 className="App_pageTitle">{props.isActivation ? "Create your password" : "Forgot your password?"}</h1>
      <p className="App_formDesc">{props.isActivation ? `Please continue to create your password for user ${userId}` : "Don’t worry. Resetting your password is easy, just tell us the username you registered with"}.</p>
      {props.errorMessage && <ErrorMessage>{props.errorMessage}</ErrorMessage>}
      {!props.isActivation && <div className="App_formInputGroup">
        <FormInput
          id="userID"
          className="input100"
          placeholder="Username"
          label=""
          disabled={props.isActivation}
          type="email"
          value={userId}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setUserId(event.target.value)}
          autoComplete="username"
        />
      </div> }
      <div className="App_formButtonGroup">
        <a
          href="javascript:void(0)"
          className="UsernameForm_ResetPwdButton"
          onClick={onCancelButtonClick}>
          Cancel
        </a>
        <Button
          className={`login100-form-btn ${props.tenant}-btn`}
          variant={ButtonVariant.primary}
          type="submit"
          disabled={userId.length === 0}
          onClick={onSubmitButtonClick}
          theme={MITheme.dark}
          size={ButtonSize.large}>
          {props.isActivation ? "Continue" : "Submit"}
        </Button>
      </div>
      <p className="txt2 welcome-desc">Need more help logging in? Please contact our tech support team <span>(<a href={MAILTOFOGOTPASSWORD.link}>{MAILTOFOGOTPASSWORD.text}</a>)</span>.</p>
    </form>
  );
}